export var FALLBACK_HANDLER_FRIENDLY_NAME="NONE";